import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
const colors = new Colors();

const Thumbnail = ({track, color, onClick, isSelected}) => { 
    let style = {
        backgroundColor: color
    };
    if (track.sample) {
        let url = track.sample.getThumbnail();
        if (url && url !== '') {
            console.log('url = ', url);
            style.backgroundImage = 'url(' + url + ')';
        } 
    } 
    
    return (
        <div
          onClick={onClick}
          style={style}
          className={isSelected ? "mini-thumbnail selected" : "mini-thumbnail"}>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Thumbnail);
